@let workflowInstances = $workflowInstances();
@let runningStep = $runningStep();
@let loading = $loading();
@let fileId = $fileId();
@let authorizations = $authorizations();

@if (loading) {
  <div class="skeleton-activity">
    <p-skeleton height="70px" class="skeleton-activity" styleClass="mb-2" />
  </div>
} @else {
  <div class="activity-container">
    <span class="span-header">Activity</span>

    @for (instance of workflowInstances; track instance.id) {
      @let state = getWorkflowState(instance);

      <p-panel
        toggleable
        [collapsed]="instance.state !== WorkflowInstanceState.WAITING"
        collapseIcon="pi pi-chevron-down"
        expandIcon="pi pi-chevron-up"
      >
        <ng-template pTemplate="header">
          <div class="activity-row">
            <div class="activity-row-begin">
              <div class="state-icon">
                <i class="{{ state.icon }} state-icon"></i>
              </div>

              <div
                class="workflow-name"
                [pTooltip]="state.value"
                tooltipPosition="top"
              >
                {{ instance.template.name }}
              </div>
              @if (
                instance.template.type !== WorkflowTemplateType.AUTOMATIC &&
                [WorkflowInstanceState.COMPLETED, WorkflowInstanceState.CANCELED].includes(
                  instance.state
                )
              ) {
                <p-tag
                  class="workflow-status version-colors"
                  [class]="state.class"
                  [value]="getWorkflowInstanceFormatedVersion(instance)"
                />
              }

              @if (instance.pdf_file_id) {
                <div
                  class="pdf-export"
                  role="button"
                  (click)="drivePreview.emit(instance.pdf_file_id!)"
                >
                  <i class="pi pi-file-pdf"></i>
                </div>
              }
            </div>

            @if (instance.finished_at) {
              <div
                class="date"
                [pTooltip]="getTimeFromDate(instance.finished_at)"
                tooltipPosition="top"
              >
                {{ instance.finished_at | date: 'dd/MM/yy' }}
              </div>
            }
          </div>
        </ng-template>

        <div class="timeline">
          <div class="bullet">
            <span></span>
          </div>
          <div class="content">
            <span
              class="step-label-name"
              [pTooltip]="getWorkflowOriginTooltip(instance)"
            >
              {{ getWorkflowOriginMessage(instance) }}
            </span>
            <div
              class="date"
              [pTooltip]="getTimeFromDate(instance.created_at)"
              tooltipPosition="left"
            >
              {{ instance.created_at | date: 'dd/MM/yy' }}
            </div>
          </div>
          @for (step of instance.steps; track step.id) {
            @let stepState = getWorkflowStepState(instance, step);
            <div class="bullet"><span></span></div>
            <div class="content">
              <div class="step-row-begin">
                <span
                  class="step-label-name"
                  [pTooltip]="getWorkflowStepTooltip(step)"
                  tooltipPosition="top"
                >
                  {{ step.template.name }}
                </span>
                <p-tag
                  class="workflow-status"
                  [pTooltip]="stepState.value"
                  tooltipPosition="right"
                  [icon]="stepState.icon"
                  [class]="stepState.class"
                />
              </div>

              @if (step.state_modified_at) {
                <div
                  class="date"
                  [pTooltip]="getTimeFromDate(step.state_modified_at)"
                  tooltipPosition="left"
                >
                  {{ step.state_modified_at | date: 'dd/MM/yy' }}
                </div>
              }
            </div>
          }

          @if (fileId && instance.file_id && instance.file_id !== fileId) {
            <div class="bullet">
              <span></span>
            </div>
            <div class="content">
              <div class="step-row-begin">
                <div class="state-icon">
                  <i class="pi pi-eye state-icon"></i>
                </div>
                <span
                  class="step-link"
                  role="link"
                  (click)="drivePreview.emit(instance.file_id)"
                >
                  Link to original file
                </span>
              </div>
            </div>
          }
        </div>
      </p-panel>

      @if (
        instance.state !== WorkflowInstanceState.CANCELED &&
        runningStep &&
        instance.steps.includes(runningStep)
      ) {
        @if (
          runningStep.template.type === WorkflowTemplateStepType.USER_VALIDATION
        ) {
          <div class="actions">
            <p-button
              label="Reject"
              [outlined]="true"
              size="small"
              [disabled]="!authorizations?.can_reject"
              (onClick)="rejectWorkflowEvent.emit(runningStep.id)"
            />
            <p-button
              label="Approve"
              size="small"
              [disabled]="!authorizations?.can_approve"
              (onClick)="approveWorkflow(instance, runningStep)"
            />
          </div>
        }
        @if (
          runningStep.template.type ===
          WorkflowTemplateStepType.USER_ACKNOWLEDGEMENT
        ) {
          <div class="actions">
            <p-button
              label="Acknowledge"
              size="small"
              [disabled]="!authorizations?.can_acknowledge"
              (click)="acknowledgeWorkflowEvent.emit(runningStep.id)"
            />
          </div>
        }
      }
    }

    @if (!runningStep && $templates() > 0) {
      <p-button
        label="Start approbation"
        size="small"
        class="margin-top-button-action"
        (onClick)="startWorkflowEvent.emit()"
      />
    }
  </div>
}
